module.exports = __webpack_public_path__ + "static/media/plans.93619916.jpg";